import React from "react"
import styles from "./knowledgebase-post-grid.module.scss"

const KnowledgebasePostGrid = ({ children, fullWidth }) => (
  <div className={`container ${styles.grid} ${fullWidth? styles.fullWidth: ''}`}>
    {children}
  </div>
)

export default KnowledgebasePostGrid